// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { ShopOrderLabelQuantityType } from "src/api/generated/erp/production/service/shopOrder/shopOrderLabelQuantityType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderPrintApi {
	export async function printSurveysOfShopOrderOperations(args: {
		shopOrderId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/printSurveysOfShopOrderOperations",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printShopOrderPickingList(args: {
		shopOrderLineIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/printShopOrderPickingList",
			method: "POST",
			data: {
				shopOrderLineIds: args.shopOrderLineIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printShopOrderWorkInstructions(args: {
		shopOrderId?: number | null | undefined;
		shopOrderIds?: Array<number> | null | undefined;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/printShopOrderWorkInstructions",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
				shopOrderIds: args.shopOrderIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printShopOrderWorkInstructionsForBatch(args: {
		shopOrderBatchId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/printShopOrderWorkInstructionsForBatch",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printShopOrderLabel(args: {
		shopOrderIds: Array<number>;
		quantityType?: ShopOrderLabelQuantityType;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/printShopOrderLabel",
			method: "POST",
			data: {
				shopOrderIds: args.shopOrderIds,
				quantityType: args.quantityType,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function setWorkInstructionIsPrinted(args: { shopOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/setWorkInstructionIsPrinted",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as void;
	}

	export async function unsetWorkInstructionIsPrinted(args: { shopOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/unsetWorkInstructionIsPrinted",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as void;
	}

	export async function setPartListIsPrinted(args: { shopOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/setPartListIsPrinted",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as void;
	}

	export async function unsetPartListIsPrinted(args: { shopOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/unsetPartListIsPrinted",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as void;
	}
}
